function headerTippyTop() {
	if ($('.desktopPage').length > 0) {
		$('#welcome-message').hover(function () {
			$('.accountDDContainer').show();
			$('#loginButton').attr('aria-expanded', 'true');
		});
		$('#welcome-message').on('mouseleave', function () {
			$('.accountDDContainer').hide();
			$('#loginButton').attr('aria-expanded', 'false');
		});
	}
	$('#welcome-message').on('click', function () {
		$('.accountDDContainer').toggle();
		if ($('#accountDDContainer').css('display') == 'block') {
			$('#loginButton').attr('aria-expanded', 'true');
		} else {
			$('#loginButton').attr('aria-expanded', 'false');
		}
	});
}

function animationObserver() {
	if (window.ES_Header_Promo_JSONContent != undefined && window.ES_Header_Promo_JSONContent.length != 0) {
		var rootElement = document.querySelector('.header_promo_wrapper');
		if (window.IntersectionObserver) {
			if (animationObserver) {
				animationObserver.disconnect();
			}
			var options = {
				root: rootElement,
				rootMargin: '0px',
				threshold: 0.5,
			};

			var animationObserver = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.ariaHidden = 'false';
						entry.target.firstElementChild.firstElementChild.setAttribute('tabindex', '0');
					} else {
						entry.target.ariaHidden = 'true';
						entry.target.firstElementChild.firstElementChild.setAttribute('tabindex', '-1');
					}
				});
			}, options);

			document.querySelectorAll('#animatedPromo .promoHeadingContainer').forEach((promoSlide) => {
				animationObserver.observe(promoSlide);
			});
		}
	}
}

// fix for iOS tablet edge cases - animation skipping on rotation
function handleAnimationRotation() {
	if ($('.tabletPage #animatedPromo').length > 0 && (window.ES_Header_Promo_JSONContent != undefined && window.ES_Header_Promo_JSONContent.length != 0)) {
		window.addEventListener('orientationchange', function() {
			var animatedPromo = document.getElementById('animatedPromo');
			animatedPromo.setAttribute('style', 'animation-play-state: paused!important')
			setTimeout(function() {
				animatedPromo.removeAttribute('style');
				window.removeEventListener('orientationchange', null);
			}, 2000);
		})
	}
}

function slickyTippy() {
	if (window.ES_Header_Promo_JSONContent != undefined) {
		var promoCount = 'promoCount-' + window.ES_Header_Promo_JSONContent.length;
		$('#animatedPromo').addClass(promoCount);
	}
	(window.ES_Header_Promo_JSONContent || []).map((attr, index) => {
		var testDiv = `<div class="promoHeadingContainer">${attr}</div>`;
		$('#animatedPromo').append(testDiv);
	});

	$('.pausePlayButton').on('click', function () {
		if (!$('.pausePlayButton svg').hasClass('playButtonTippy')) {
			$('#animatedPromo').css('animation-play-state', 'paused');
			$('.pausePlayButton').html(
				"<svg class='playButtonTippy' role='img' aria-labelledby='playButton' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42.43 48.31' width='15'><title id='playButton'>play promo</title><g data-name='Layer 2'><g data-name='Layer 1'><path d='M2.63.46,42,23.06a1.54,1.54,0,0,1,0,2.19L2.63,47.86A1.54,1.54,0,0,1,0,46.76V1.55A1.54,1.54,0,0,1,2.63.46Z' /></g></g></svg>Play"
			);
		} else {
			$('#animatedPromo').css('animation-play-state', 'running');
			$('.pausePlayButton').html(
				"<svg className='pauseButtonTippy' role='img' aria-labelledby='pauseButton' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 47' width='15'><title id='pauseButton'>pause promo</title><g data-name='Layer 2'><g data-name='Layer 1'><rect width='17' height='47' rx='2.2' /><rect x='28' width='17' height='47' rx='2.2' /></g></g></svg> Pause"
			);
		}
	});

	$(window).on('scroll', function () {
		if ($('.desktopPage').length > 0 && $('#layoutCheckout').length == 0) {
			const initialPosition = window.pageYOffset || document.documentElement.scrollTop;
			if (document.querySelector('#topbar-wrapper')) {
				if (document.querySelector('#topbar-wrapper').getBoundingClientRect().top <= 1 && initialPosition > 0) {
					$('#topbar-wrapper #myDillardsBar').css('cssText', 'position: fixed !important');
					$('#topbar-wrapper #myDillardsBar').addClass('blackDillardsBar');
					$('#topbar-wrapper #myDillardsBarContent li a.sale-clearance').hide();
					$('.i-empty-shopping-bag svg').css('fill', 'white');
					$('.loginArrowDown svg').css('fill', 'white');
					//$('[href=/c/shopbybrand]').hide();
					$('#topbar-wrapper #myDillardsBarContent li a[href*="/c/shopbybrand"]').hide();
					$('#topbar-wrapper #myDillardsBarContent li a.text--limitedAvailability').hide();
				} else {
					$('#topbar-wrapper #myDillardsBar').css('cssText', 'position: absolute !important');
					$('#topbar-wrapper #myDillardsBar').removeClass('blackDillardsBar');
					$('#topbar-wrapper #myDillardsBarContent li a.sale-clearance').show();
					$('.i-empty-shopping-bag svg').css('fill', 'black');
					$('.loginArrowDown svg').css('fill', 'black');
					//$('[href=/c/shopbybrand]').show();
					$('#topbar-wrapper #myDillardsBarContent li a[href*="/c/shopbybrand"]').show();
					$('#topbar-wrapper #myDillardsBarContent li a.text--limitedAvailability').show();
				}
			}
		}
	});
}

function hideWhileLoading () {
	$(window).on('load', function() {
		$(".barItems").show();
	});
}

var skiptoContent = function () {
	if ($('.desktopPage').length > 0 && $('#skipNavigation').length > 0) {
		$('#skipNavigation').on('click', function () {
			$('html, body').animate({ scrollTop: $('#content-wrapper').offset().top - 110 }, 50);
		});
	}
};

export { headerTippyTop, animationObserver, handleAnimationRotation, slickyTippy, skiptoContent, hideWhileLoading };
